const TRANSCRIPT_VIEW_TYPES = {
  FULL: 'TRANSCRIPT_VIEW_TYPES_FULL',
  ADMIN_PREVIEW: 'TRANSCRIPT_VIEW_TYPES_ADMIN_PREVIEW',
  CLIENT_PREVIEW: 'TRANSCRIPT_VIEW_TYPES_CLIENT_PREVIEW',
};

module.exports = { TRANSCRIPT_VIEW_TYPES };



// WEBPACK FOOTER //
// ./config/transcriptViewConfig.js